import styled from "styled-components";

const StyledModal = styled.div`
  display: flex;

  flex-direction: column;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto; // Adjust based on the content size

  justify-content: start; // Aligns orders to the start of the grid
  gap: 1rem; // Equivalent to 20px if 1rem = 16px.
  // padding: 1rem; // Adds some spacing inside the container, adjust as necessary.
  box-sizing: border-box; // Ensures padding and border are included in the width calculation.
`;

const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;

  align-content: flex-start;
  min-height: 10rem;
  height: auto;
  padding: 1rem;
  background-color: "var(--backdrop-color-ex)";
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div);
  border-radius: 1rem;
  margin-bottom: 1.5rem;
`;

const ServiceTimeContainer = styled.div`
  display: flex;
  width: 60rem;
  align-content: flex-start;
  min-height: 10rem;
  height: auto;
  padding: 2rem;
  background-color: ${(props) =>
    props.$type === "current"
      ? "var(--backdrop-color-ex)"
      : "var(--backdrop-color)"};
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  border-radius: 1rem;
  margin-bottom: 1.5rem;
`;

const StyledState = styled.div`
  display: flex;

  gap: 0.4em; // Adjust the gap as needed
`;

const StyledAssetGroup = styled.h4`
  color: var(--color-grey-500);
  white-space: nowrap;
`;

const StateCircle = styled.span`
  background-color: ${(props) => getStateColor(props.$state)};
  border-radius: 50%; // Make it a circle
  width: 1em;
  height: 0.8em;
  display: inline-block;
`;

const OrderLink = styled.a`
  color: var(
    --color-primary
  ); // Use your theme's primary color or any color you prefer
  text-decoration: none; // Optional: removes underline from links

  &:hover {
    text-decoration: underline; // Optional: adds underline on hover for better UX
  }
`;

const StateText = styled.span`
  font-size: 0.6em;
  color: var(--color-grey-800);
`;

const StyledIdent = styled.h4`
  color: var(--color-grey-500);
  font-size: 0.8em;
  margin-left: 1rem;
`;

const StyledDate = styled.h4`
  color: var(--color-grey-500);
  font-size: 0.8em;
  margin-left: 1rem;
  text-align: right; /* Right-align the content */
  flex-grow: 1; /* Push the date to the right if inside a flex container */
`;

const PlanningDays = styled.span`
  color: red;
  font-size: 0.8em;
  margin-left: 1em;
`;

const StyledDescription = styled.h5`
  font-weight: 50;
  color: ${(props) =>
    props.$type === "failed"
      ? "var(--color-grey-600)"
      : "var(--color-grey-800)"};
  margin-top: ${(props) => (props.$type === "failed" ? "1em" : null)};
  overflow-y: hidden; /* Default to hidden to avoid visible scrollbars */
  max-height: calc(
    1.2em * 10
  ); /* Limit the height to 10 lines, adjust as needed */
  line-height: 1.2em; /* Adjust line height as needed */
  display: -webkit-box;
  -webkit-line-clamp: 20; /* Limit the content to 20 lines */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  transition: overflow-y 0.3s; /* Smoothly show/hide scrollbars */

  &:hover {
    overflow-y: auto; /* Enable scrolling on hover */
  }

  /* Optional: Style the scrollbar for WebKit browsers */
  &::-webkit-scrollbar {
    width: 8px; /* Set the width of the scrollbar */
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--color-grey-400); /* Customize scrollbar color */
    border-radius: 4px; /* Rounded scrollbar thumb */
  }
  &::-webkit-scrollbar-track {
    background-color: var(--color-grey-200); /* Customize track color */
  }
`;

const getStateColor = (state) => {
  switch (state) {
    case "Completed":
      return "#337d33";
    case "Finished":
      return "#00cc99";
    case "In Process":
      return "#95de75";
    case "Released":
      return "#fbec9b";
    case "Planned":
      return "#a4bfff";

    default:
      return "black";
  }
};

function formatPlannedDate(dateString) {
  if (!dateString) return "No date available";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = String(date.getFullYear()).slice(-2); // Last two digits of the year
  return `${day}.${month}.${year}`;
}

function MIOrderCard({ order }) {
  const partsAfterDash = order.orderIdent.split("-")[1] || "";
  const orderId = partsAfterDash.replace(/^0+/, "");
  const orderLink = `https://tools.witron.com/Live/REMAVinterbro/MaintenanceExcellence/Orders.aspx/${orderId}`;
  return (
    <StyledModal>
      <StyledState>
        <StateCircle $state={order.state} />
        <StateText>{order.state}</StateText>
        <StyledIdent>
          <OrderLink href={orderLink} target="_blank" rel="noopener noreferrer">
            {order.orderIdent}
          </OrderLink>
        </StyledIdent>
        <StyledDate>{formatPlannedDate(order.plannedDate)}</StyledDate>
      </StyledState>

      <GridContainer>
        <OrderContainer>
          {order.description && (
            <StyledDescription>{order.description}</StyledDescription>
          )}
          {order.descrOfFailure && (
            <StyledDescription $type="failed">
              {order.descrOfFailure}
            </StyledDescription>
          )}
        </OrderContainer>
        {/* <ServiceTimeContainer>
          <MaintenanceOrderServiceTime orderId={order.orderId} />
        </ServiceTimeContainer> */}
      </GridContainer>
    </StyledModal>
  );
}

export default MIOrderCard;
